import { ProductCard } from '../entities/product/ProductCard';
import { Icon } from '../shared/ui/Icon';

export function ProductStrip({ items, title, subtitle, action, loading = false }) {
  if (!items.length && !loading) return null;

  return (
    <section className="product-section">
      <div className="section-heading">
        <div>
          {title && <p className="eyebrow">THE EDIT</p>}
          {title && <h2>{title}</h2>}
          {subtitle && <p>{subtitle}</p>}
        </div>
        {action && (
          <button className="text-link" onClick={action}>
            View all <Icon>↗</Icon>
          </button>
        )}
      </div>
      {loading
        ? <div className="product-grid" aria-label="Loading products">{Array.from({ length: 4 }, (_, index) => <div className="product-card-skeleton" key={index} />)}</div>
        : <div className="product-grid">{items.slice(0, 4).map((product) => <ProductCard product={product} key={product.id} />)}</div>}
    </section>
  );
}
